import { render } from "./BlogForm.vue?vue&type=template&id=d9bdd7aa"
import script from "./BlogForm.vue?vue&type=script&lang=js"
export * from "./BlogForm.vue?vue&type=script&lang=js"
script.render = render

export default script